import { createHashRouter } from 'react-router-dom';
import { ProtectedRoute, PublicRoute } from '@repo/auth';
import { DashboardLayout, NotFound, ErrorPage, ProfilePage } from '@repo/ui';
import { navItems } from './navigation';
import LoginPage from '@/pages/LoginPage';
import SchedulePage from '@/pages/schedule/SchedulePage';
import PaymentsPage from '@/pages/payments/PaymentsPage';
import TicketsPage from '@/pages/tickets/TicketsPage';
import AttendancePage from '@/pages/attendance/AttendancePage';
import SessionsPage from '@/pages/sessions/SessionsPage';
import GroupDetailsPage from '@/pages/groups/GroupDetailsPage';
import GroupsPage from '@/pages/groups/GroupsPage';
import DashboardPage from '@/pages/DashboardPage';

export const routes = createHashRouter([
  {
    path: '/login',
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout navItems={navItems} headerTitle="student.auth.portalName" />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: '/groups',
        element: <GroupsPage />,
      },
      {
        path: '/groups/:id',
        element: <GroupDetailsPage />,
      },
      {
        path: '/sessions',
        element: <SessionsPage />,
      },
      {
        path: '/attendance',
        element: <AttendancePage />,
      },
      {
        path: '/tickets',
        element: <TicketsPage />,
      },
      {
        path: '/payments',
        element: <PaymentsPage />,
      },
      {
        path: '/schedule',
        element: <SchedulePage />,
      },
      {
        path: '/profile',
        element: <ProfilePage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
